module.exports = __webpack_public_path__ + "img/cover 1.3 first page.0bcea53c.jpg";